import React, { useState, useEffect } from "react";
// import toast from 'react-hot-toast';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";

//Redux
import { useSelector, useDispatch } from "react-redux"; //useDispatch

//Components
import Layout from "../../../../Layout/Layout";
import Constants from "../../../../common/CustomerConstants";

import {
  addcustomerID,
  getCustomerList,
  workflow,
} from "../../../../redux/feature/customer_app/customerSlice";

import { SearchField } from "../../../../Components/formElements/SearchField";

import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
import { formatDate, formatDateTime } from "../../../../common/Validations";
import LogisticsConstants from "../../../../common/LogisticsConstants";
import GateInWordModel from "./GateInWardModel";

const GateEntryInWordOutWardList = () => {
  // eslint-disable-next-line no-unused-vars
  const dispatch = useDispatch();
  const navigate = useNavigate();
  localStorage.setItem("menu", "Logistics");
  localStorage.setItem("submenu", "Inward/Outward");

  let customerData = useSelector((state) => state?.customer); // User Details from Store
  let customerTable = useSelector((state) => state?.customer.pagination); // User Details from Store
  let config = useSelector((state) => state?.common?.data?.suppliers); // User Details from Store

  const [data, setData] = useState([]);
  const [isCardVisible, setCardVisible] = useState(true);

  const [getNewPerPage, setNewPerPage] = useState(10);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");

  /* pop success modal */
  const [modalGateShowStatus, setModalGateShowStatus] = useState(false);

  //getting cutsomer ID
  const detailedPage = (customerID) => {
    dispatch(addcustomerID(customerID));
    navigate(LogisticsConstants.LOGISTICS_GATE_ENTRY_UPDATE);
  };

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };

  /* Modal Function */

  const loadInitialSuuplierData = async () => {
    setData(customerData?.data);
  };

  const handlePageChange = (page) => {
    let obj = {
      queryName: "getLogisticsGateEntryList",
      module: "",
      page: page,
      per_page: getNewPerPage,
    };

    dispatch(getCustomerList(obj));
    setData(customerData?.data);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
      queryName: "getLogisticsGateEntryList",
      module: "",
      page: page,
      per_page: newPerPage,
    };
    setNewPerPage(newPerPage);
    dispatch(getCustomerList(obj));
    setData(customerData?.data);
  };

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    let obj = {
      queryName: "getLogisticsGateEntryList",
      module: "",
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getCustomerList(obj));
  };

  useEffect(() => {
    const fetchData = async () => {
      await loadInitialSuuplierData();
      dispatch(workflow({}));
    };

    fetchData();

    loadInitialSuuplierData(); // fetch page 1 of users
    dispatch(workflow({}));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerData?.data]);

  //on page load
  useEffect(() => {
    dispatch(addcustomerID(""));
    let obj = {
      queryName: "getLogisticsGateEntryList",
      module: "",
      page: 1,
      per_page: 10,
    };
    dispatch(getCustomerList(obj));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const gateInwardOutWardInfo = [
    {
      name: "Gate Entry Number",
      selector: (row) => row?.documentNumber,
      cell: (row) => (
        <>
          <button
            className="btnInfo"
            onClick={() => detailedPage(row?.documentNumber)}
          >
            {row?.documentNumber || "-"}{" "}
          </button>
        </>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Gate",
      selector: (row) => row.gate,
      cell: (row) => <TableStatusField status={`${row?.gate}`} />,
      sortable: true,
      width: "150px",
    },
    {
      name: "Customer Name",
      cell: (row) => (
        <>
        <p className="m-0 p-0 pt-1 fw-bold ">{row.inCustomerName} </p>
        <p className="m-0 p-0 pt-1 fw-bold ">{row.outCustomerName} </p>
        
        </>
      ),
      selector: (row) => row.salesOfficerName,
      sortable: true,
      width: "180px",
    },
    {
      name: "Vehicle Number",
      selector: (row) => row.inVehicleNumber,
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.inVehicleNumber}</p>
          <p className="m-0 p-0 pt-1 fw-bold">{row.outVehicleNumber}</p>
        </div>
      ),
      sortable: true,
      width: "160px",
    },

    {
      name: "Driver Name",
      cell: (row) => (
        <>
          <TableStatusField
            // status={JSON.stringify(row?.cashRequestStatus)}
            //  status={`${row?.gateInWardDriverName || ""}`}
            status={`${row?.inDriverName || ""}  ${row?.outDriverName || ""}`}

            // status={row?.cashRequestStatus && row?.cashRequestStatus }
          />
        </>
      ),

      width: "180px",
    },

    {
      name: "Driver Mobile No",
      selector: (row) => row.inDriverMobileNumber,
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row.inDriverMobileNumber} </p>
          <p className="m-0 p-0 pt-1 fw-bold ">{row.outDriverMobileNumber} </p>
        </div>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Weighbridge",
      selector: (row) => row.inWeightBridge,
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row.inWeightBridge} </p>
          <p className="m-0 p-0 pt-1 fw-bold ">{row.outProceedWeighBridge} </p>
          <p className="m-0 p-0 pt-1 fw-bold ">{row.outWeightBridge} </p>
        </div>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Weighbridge Name",
      selector: (row) => row.inWeightBridge,
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row.inWeighbridgeName} </p>
          <p className="m-0 p-0 pt-1 fw-bold ">{row.outWeighbridge} </p>
        </div>
      ),
      sortable: true,
      width: "180px",
    },

    // {
    //   name: "Entry Date",
    //   cell: (row) => (
    //     <div>
    //       <p className="m-0 p-0 pt-1 fw-bold ">{row.inDate} </p>
    //       {/* <p className="m-0 p-0 ">{row.salesOfficerCode} </p> */}
    //     </div>
    //   ),
    //   selector: (row) => row.salesOfficerName,
    //   sortable: true,
    //   width: "180px",
    // },
    {
      name: "Entry Date",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{formatDate(row?.inDate)} </p>
        </div>
      ),
      width: "140px",
    },
    {
      name: "Entry Time",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row.gateInwardSelectedTime} </p>
          <p className="m-0 p-0 pt-1 fw-bold ">{row.gateOutWardTime} </p>
          {/* <p className="m-0 p-0 ">{row.salesOfficerCode} </p> */}
        </div>
      ),
      selector: (row) => row.salesOfficerName,
      sortable: true,
      width: "140px",
    },

    {
      name: "Created",
      selector: (row) => formatDateTime(row.createdAt),
      sortable: true,
      width: "190px",
    },
    {
      name: "",
      selector: (row) => row.receivedBy,
      cell: (row) => (
        <>
          <span>{row.receivedBy}</span>
        </>
      ),
      sortable: true,
      width: "150px",
    },
  ];
  const showGateRequestModal = () => {
    setModalGateShowStatus(true);
  };
  const hideModalStatus = () => {
    setModalGateShowStatus(false);
  };

  return (
    <main className="dashboard main" id="main">
      {/* Spinner Overlay */}
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={9} lg={9}>
                <h2 className="mainTitle">Gate Entry List</h2>
                <p className="subText">Gate Entry List </p>
              </Col>
              <Col xs={12} md={3} lg={3} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
            </Row>
            <hr />

            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">GE</span>
                    </Col>
                    <Col xs={8} md={3} lg={3}>
                      <span className="headerTitle">Gate Entry</span>
                      <span className="subHeaderTitle">Gate </span>
                    </Col>

                    <Col xs={12} md={6} lg={6} className="headerButtonAlign">
                      <Col xs={{ span: 4, offset: 8 }} md={2} lg={2} className="">
                        <button
                          className="btnTable"
                          onClick={() => showGateRequestModal()}
                        >
                          Create Gate Entry
                        </button>
                      </Col>

                      {config?.filter && (
                        <Col xs={2} md={1} lg={1} className="">
                          <>
                            <div className="filter">
                              <span
                                className="icon hide headerIcon"
                                data-bs-toggle="dropdown"
                                aria-expanded="true"
                              >
                                <i className="bi bi-three-dots"></i>
                              </span>
                              <ul
                                className="dropdown-menu dropdown-menu-end dropdown-menu-arrow hide menuList"
                                data-popper-placement="bottom-end"
                              >
                                <li className="dropdown-header text-start">
                                  <h6>Menu</h6>
                                </li>

                                <li>
                                  <span
                                    className="dropdown-item headerIcon"
                                    onClick={() => handleSearchFuncApi()}
                                  >
                                    <i class="bi bi-arrow-clockwise"></i>
                                    Refresh Data
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </>
                        </Col>
                      )}
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={gateInwardOutWardInfo}
                          data={data}
                          progressPending={customerData?.status}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          paginationTotalRows={customerTable.total}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          // selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <GateInWordModel
        show={modalGateShowStatus}
        onHide={() => hideModalStatus()}
      />
    </main>
  );
};

export default GateEntryInWordOutWardList;
